/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useCallback } from 'react';
import { FunctionComponent } from 'react';
import { useDispatch } from 'react-redux';
import { closeDialog } from '../../../app/dialog/dialog.actions';
import { SubmitButton } from '../../pages/common/forms/SubmitButton';
import { ConnectedDialog } from '../ConnectedDialog';
import { MeetingShortcutDeleteFileForm } from '../../pages/common/forms/MeetingShortcutDeleteFileForm';
import { IMeetingShortcutDeleteFileDialog } from './types';

export const MeetingShortcutDeleteFileDialog: FunctionComponent<IMeetingShortcutDeleteFileDialog> = ({
  folderFileId,
}) => {
  const dispatch = useDispatch();

  const onClose = useCallback(() => {
    dispatch(closeDialog('meetingShortcutDeleteFileDialog'));
  }, [dispatch]);

  return (
    <ConnectedDialog dialogKey="meetingShortcutDeleteFileDialog">
      <div className="popup new_trello_card_popup" style={{ display: 'block' }}>
        <div className="panel">
          <div className="panel-header small-header flex jcsb">
            <h3>Delete Shortcut</h3>
            <span className="close-popup close" onClick={onClose}>
              <i className="icon-close" />
            </span>
          </div>
          <div className="panel-body">
            <MeetingShortcutDeleteFileForm />
          </div>
          <div className="panel-footer no-border flex jcr">
            <a className="link blueGray mr-2 close" onClick={onClose}>
              Close
            </a>
            <SubmitButton apiKey={'deleteFileFolder'} formName={'team-files-delete-file-form'} text="Save" />
          </div>
        </div>
      </div>
    </ConnectedDialog>
  );
};
